<template>
  <b-modal
    id="myid"
    ref="modal"
    title="출제 포인트 생성"
    @show="resetModal"
    @ok="handleOk"
  >
    <b-overlay :show="loading" rounded="sm">
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group label="타입" label-for="intent_typeX">
          <b-form-radio-group
            id="intent_typeX"
            v-model="intent_typeX"
            :options="intent_type1_field"
            class="mb-3"
            value-field="value"
            text-field="text"
            disabled-field="notEnabled"
          ></b-form-radio-group>
        </b-form-group>

        <b-form-group
          label="대분류(D1)"
          label-for="d1"
          invalid-feedback="대분류는 비어있을수 없습니다."
          :state="d1State"
        >
          <b-form-input
            id="d1"
            v-model="d1"
            :state="d1State"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="중분류(D2)"
          label-for="d2"
          invalid-feedback="중분류는 비어있을수 없습니다."
          :state="d2State"
        >
          <b-form-input
            id="d2"
            v-model="d2"
            :state="d2State"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group label="소분류(D3)" label-for="d2">
          <b-form-input id="d3" v-model="d3"></b-form-input>
        </b-form-group>
        <b-form-group label="사용여부" label-for="useyn">
          <b-form-radio-group
            id="useyn"
            v-model="useyn"
            :options="intent_useyn_field"
            class="mb-3"
            value-field="value"
            text-field="text"
            disabled-field="notEnabled"
          ></b-form-radio-group>
        </b-form-group>
        <div v-if="changed1" class="warning">
          *대분류가 수정되었습니다. 해당이름으로 관련문항전체를 변경합니다.
        </div>
        <div v-if="changed2" class="warning">
          *중분류가 수정되었습니다. 해당이름으로 관련문항전체를 변경합니다.
        </div>
        <div v-if="changed3" class="warning">
          *소분류가 수정되었습니다. 해당이름으로 관련문항전체를 변경합니다.
        </div>
      </form>
    </b-overlay>
  </b-modal>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
// import { cloneDeep, sortBy } from "lodash/core";
import * as _ from "lodash";
export default {
  props: ["item"],
  data() {
    return {
      d1: "",
      d2: "",
      d3: "",
      id: null,
      useyn: "Y",
      target_vorder: null,
      loading: false,

      d1State: null,
      d2State: null,
      d3State: null,
      origin: {},

      changed1: false,
      changed2: false,
      changed3: false,

      submittedNames: [],
    };
  },
  watch: {
    d1(dat) {
      if (this.id != null) {
        this.changed1 = this.origin.d1 === dat ? false : true;
      }
    },
    d2(dat) {
      if (this.id != null) {
        this.changed2 = this.origin.d2 === dat ? false : true;
      }
    },
    d3(dat) {
      if (this.id != null) {
        this.changed3 = this.origin.d3 === dat ? false : true;
      }
    },
  },
  computed: {
    ...mapState("intentStore", ["gbn1", "gbn2", "gbn3", "intent_type"]),
    intent_type1_field() {
      return [
        { value: 1, text: "문풀훈련형" },
        { value: 2, text: "문장훈련형" },
      ];
    },
    intent_useyn_field() {
      return [
        { value: "Y", text: "사용" },
        { value: "N", text: "미사용" },
      ];
    },
    intent_typeX: {
      set(val) {
        this.$store.commit("intentStore/updateIntentType", val);
      },
      get() {
        return this.intent_type;
      },
    },

    intent_field() {
      return this.$store.state.intent_field;
    },
  },
  methods: {
    ...mapActions("intentStore", [
      "saveIntent",
      "saveSenIntent",
      "putIntent",
      "putSenIntent",
      "LoadIntentForAdmin",
      "LoadSenIntentForAdmin",
    ]),
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.nameState = valid;
      this.d1State = _.isEmpty(this.d1) ? false : true;
      this.d2State = _.isEmpty(this.d2) ? false : true;

      return valid;
    },
    resetModal() {
      // this.d1 = "";
      // this.d2 = "";
      // this.d3 = "";
      // this.id = null;

      this.d1 = this.item.d1;
      this.d2 = this.item.d2;
      this.d3 = this.item.d3;
      this.id = this.item.id;
      this.useyn = this.item.useyn;
      this.target_vorder = this.item.target_vorder;

      this.d1State = null;
      this.d2State = null;
      this.d3State = null;
      this.changed1 = false;
      this.changed2 = false;
      this.changed3 = false;

      this.loading = false;

      this.origin = _.cloneDeep({
        d1: this.d1,
        d2: this.d2,
        d3: this.d3,
      });
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    async handleSubmit() {
      if (!this.checkFormValidity()) {
        return;
      }
      // Push the name to submitted names
      //   this.submittedNames.push(this.name);
      // Hide the modal manually
      this.loading = true;
      let payload = {
        d1: this.d1,
        d2: this.d2,
        d3: this.d3,
        id: this.id,
        vorder: this.target_vorder,
        useyn: this.useyn,
      };

      if (this.intent_typeX == 1) {
        if (this.item.id === undefined) {
          let k = await this.saveIntent(payload);
          await this.LoadIntentForAdmin("");
        } else {
          //put

          let k = await this.putIntent(payload);
        }
      } else if (this.intent_typeX == 2) {
        if (this.item.id === undefined) {
          //post
          let k = await this.saveSenIntent(payload);
          await this.LoadSenIntentForAdmin("");
        } else {
          //put
          let k = await this.putSenIntent(payload);
        }
      }

      this.item.d1 = this.d1;
      this.item.d2 = this.d2;
      this.item.d3 = this.d3;
      this.item.useyn = this.useyn;
      this.$nextTick(() => {
        this.$bvModal.hide("myid");
        this.loading = true;
      });
    },
  },
};
</script>


<style lang="scss" scoped>
.warning {
  color: crimson;
  font-size: 0.9em;
}
</style>